export default __webpack_public_path__ + "static/media/TPF-BlueLogo.bc70e238.svg";